import { Pipe, PipeTransform } from '@angular/core';
import { renderMarkdown } from './co-visr-markdown.utils';

/**
 * Renders an agent message as HTML. Pure, so a streaming bubble only re-parses when its
 * text actually changes.
 */
@Pipe({ name: 'coVisrMarkdown', standalone: true })
export class CoVisrMarkdownPipe implements PipeTransform {
  transform(value: string): string {
    return renderMarkdown(value);
  }
}
